import { FormField, Button } from '@weirgroup/weir-dls'
import assetsApi from '../../../api/assets.api'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { BucketDataType } from '../../../types/bucketTypes'
import { useTranslation } from 'react-i18next'
import { StorageService } from '../../../services/storage_service'
import { isValidEmail } from '../../../utils/email.util'
import { useDarkMode } from '../../../hooks/use-darkmode'
import "../styles.scss"
import { useGlobalError } from '../../../contexts/global-error.context'
import { useAnalyticsEvent } from '../../../hooks/useAnalyticsEvent'
import { LoadingSpinner } from '../../loading-spinner'

interface Props {
    isGuest: boolean
    setIsModalShown: Dispatch<SetStateAction<any>>
    fetchBucketList: (arg?: boolean) => Promise<void>
    selectedAsset: BucketDataType
}

const Transfer = (props: Props) => {
    const {showError,showSuccess} = useGlobalError()
    const {
        isGuest,
        setIsModalShown,
        fetchBucketList,
        selectedAsset,
    } = props
    const logAnalyticsEvent = useAnalyticsEvent()
    const userData = StorageService.getItem('userData')
    const userEmail = userData ? JSON.parse(userData).email : ''

    const [email, setEmail] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showToast, setShowToast] = useState<boolean>(false)
    const [isEmailValid, setIsEmailValid] = useState<boolean>(true)
    const {darkMode} = useDarkMode();
    const { t } = useTranslation()

    useEffect(() => {
        if (showToast) {
            setTimeout(() => setShowToast(false), 5000)
        }
    }, [])
    useEffect(() => {
         logAnalyticsEvent('web_user_viewed_transfer_tab', { description: 'User viewed transfer tab'});
    },[])

    const handleEmailChange = (e: any) => {
        const emailValue = e.target.value
        setEmail(emailValue)
        setIsEmailValid(isValidEmail(emailValue))
    }

    const transfer = async () => {
        if (email === userEmail || !isValidEmail(email)) {
            showError(
                !isValidEmail(email)
                    ? t('transferInvalidEmail')
                    : t('transferSameEmailErrorMsg')
            )
        } else {
            setIsLoading(true)
            assetsApi
                .transferAsset(selectedAsset.asset_id, email)
                .then(async (res) => {
                    showSuccess(t('transferSuccess'))
                    setIsLoading(false)
                    //show success toast
                    //close modal
                    setIsModalShown(false)
                    //trigger refetch of assets
                    fetchBucketList(false)
                    logAnalyticsEvent('web_user_transferred_asset', { description: 'User transferred an asset', assetId: selectedAsset.asset_id });
                })
                .catch((err) => {
                    setIsLoading(false)
                    showError(
                        err.response.data.message || t('transferFail')
                    )
                })
        }
    }

    return (
        <div className="transfer" data-testid="transfer">
            <p className="title" style={{color:darkMode ? "white" : "gray"}}>{t('transferTitle')}</p>
            <FormField
                darkMode={darkMode}
                name="InputBox"
                label={t('transferRecipient')}
                size={'sm'}
                width={'100%'}
                placeholder={t('enterEmail')}
                onChange={handleEmailChange}
                autoComplete="off"
                required={true}
                disabled={isGuest}
                error={!isEmailValid && email !== ''}
                errorMessage={!isEmailValid && email !== '' ? t('transferInvalidEmail') : ''}
            />
            <div className="transfer-btn" data-testid="transfer-btn">
                <Button
                    darkMode={darkMode}
                    label={'Transfer'}
                    size={'sm'}
                    variant={'primary'}
                    disabled={isGuest || !isEmailValid || email === ''}
                    onClick={() => transfer()}
                />
            </div>
            {isLoading ? (
                <LoadingSpinner darkMode={darkMode} />
            ) : (
                <></>
            )}
        </div>
    )
}

export default Transfer;